import classNames from 'classnames'
import ProcessMath from './ProcessMath'
import P from 'components/typography/Paragraph'
import styles from './styles/Abstract.css'
import { highlightText } from '../../lib/highlight-text'
import BlurOverPaywall from './BlurOverPaywall'

const PLACEHOLDER_ABSTRACT = `
Exaggerated anticipatory anxiety is common in social anxiety disorder (SAD).
Neuroimaging studies have revealed altered neural activity in response to social stimuli in SAD, but fewer studies have examined neural activity during anticipation of feared social stimuli in SAD.
The current study examined the time course and magnitude of activity in threat processing brain regions during speech anticipation in socially anxious individuals and healthy controls (HC).
Method Participants (SAD n = 58; HC n = 16) underwent functional magnetic resonance imaging (fMRI) during which they completed a 90s control anticipation task and 90s speech anticipation task.
`

export const Abstract = ({
  className,
  abstract,
  textMatch,
  blur
}) => {
  if (blur) {
    return <BlurOverPaywall contentType='abstract' placeholder={PLACEHOLDER_ABSTRACT} />
  }
  if (!abstract) {
    return (
      <P className={classNames(styles.abstract, styles.noAbstract, className)}>
        No abstract
      </P>
    )
  }

  return (
    <P className={classNames(styles.abstract, className)}>
      <ProcessMath>
        <span dangerouslySetInnerHTML={{ __html: highlightText(abstract, textMatch) }} />
      </ProcessMath>
    </P>
  )
}

export default Abstract
